export default __webpack_public_path__ + "static/media/ic-x-red.1d7d0971.svg";